module.exports = __webpack_public_path__ + "img/dru-logo-02.e89c0f17.svg";